<template>
  <div style="display: flex;flex: 1;justify-content: space-between">
    <div
        @click="sVipBuy()"
        class="s-vip-price"
        style="flex: 1"
    >
      <span>
          <template v-if="couponList.couponTypeDesc">
            ¥{{ couponPrice(form.finalPriceCNY,couponList.couponFaceValue) }}
          </template>
          <template v-else>
            ¥{{ form.finalPriceCNY }}
          </template>
        </span>
      <span class="s-vip-price-tip">单独购买</span>
    </div>
    <div @click="sVip()" class="s-vip-price" style="margin-left: 10px;background: #FED690;">
      <span class="s-vip-price-t">开通会员免费学</span>
      <span class="s-vip-price-tip">畅学400+护士必备好课</span>
    </div>
  </div>

</template>

<script>
import {listUserNurseCouponUsaApp} from "@/api/shareH5";
import {dataBuryingPoint, gotoNative} from "@/utils/JSBridge";
import Config from "@/config/app";
import {isClient} from "@/utils/isTerminal";
import {hsjH5BurialPoint} from "@/utils/shareCommon";
import {Toast} from "vant";
import callApp from "@/config/callApp";

export default {
  name: 'SVipBtn',
  props: {
    isLogin:{
      type:Boolean,
      default:true
    },
    form: Object,
  },
  data:function (){
    return {
      useCourseCoupon:false,
      couponList:{
        couponTypeDesc:"",
        couponFaceValue:""
      }
    }
  },
  methods:{
    sVip(){
      if(isClient){
        dataBuryingPoint("BX00010", "BX00010-001", {
          id: PAGE_PARAMS.courseId,
          name: this.form.name
        });
        setTimeout(()=>{
          gotoNative(
              `nurse://otherLink?url=${Config.SVipUrl}/vipDetails.html`
          );
        },300)
      }else {
        hsjH5BurialPoint("BSVIP26", "BSVIP26-001", { id: PAGE_PARAMS.courseId });
        // this.downloadHsjApp()
        this.$emit('h5VipBuy')
      }

    },
    sVipBuy(){
      if(isClient){
        dataBuryingPoint("BX00010", "BX00010-002", {
          id: PAGE_PARAMS.courseId,
          name: this.form.name
        });
      }else {
        hsjH5BurialPoint("BSVIP26", "BSVIP26-002", { id: PAGE_PARAMS.courseId });
      }
      setTimeout(()=>{
        this.$emit('buy',this.useCourseCoupon)
      },300)
    },
    couponPrice(p = 0,cp = 0){
      if(cp>p){
        return 0.00
      }
      return (p-cp).toFixed(2)
    },
  },
  created() {
    let courseId = PAGE_PARAMS.courseId;
    const courseCoupon = this.form.courseCouponPoolRelationConfig
    const hasCourseCoupon =  courseCoupon && courseCoupon.couponPoolDetailVO && courseCoupon.couponPoolDetailVO.id
    if(hasCourseCoupon){
      this.useCourseCoupon = true;
      this.couponList = {couponTypeDesc:"---",couponFaceValue:courseCoupon.couponPoolDetailVO.couponFaceValueYuan}
    }
    if(!this.isLogin){
      return
    }
    listUserNurseCouponUsaApp({commodityId: courseId}).then(r => {
      if(Array.isArray(r) && r.length != 0){
        //this.couponList = r[0];
        if(hasCourseCoupon){
          if (r[0].couponFaceValue > this.couponList.couponFaceValue){
            this.couponList = r[0];
            this.useCourseCoupon = false;
          }
        }else {
          this.couponList = r[0];
        }
      }
    }).catch(_ => {})
  }
}
</script>

<style scoped lang="scss">
.s-vip-price{
  background: #FFEECF;
  border: 1px solid #FED690;
  color: rgba(114, 57, 28, 0.79);
  font-size: 16px;
  height: 40px;
  border-radius: 20px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  .s-vip-price-t{
    font-size: 15px;
    color: #72391C;
    font-weight: bold;
  }
  .s-vip-price-tip{
    font-size: 12px;
    color: #813824;
    font-weight: 400;
  }
}
</style>
